<template>

  <div>
    <!-- supplier Modal -->
    <b-modal
        v-model="showModalInternal"
        id="drugstore-select-modal-form"
        scrollable
        :title="title"
        title-class="font-18"
        size="xl"
        style="z-index:100010!important;"
        hide-footer

    >
      <div v-if="showModalInternal">
        <DrugstoresList :multiselect="multiselect" @onSelect="selectDrugstores"
                        @onSelectRow="selectDrugstore($event)"
                        :showRowActions="showRowActions"
                        :showMassActions="showMassActions"
                        :selectedDrugstoresData="selectedDrugstoresData"
                        :showAddButton="showAddButton"
                        :disableInitiallyCheckedItems="disableInitiallyCheckedItems"
                        :ignoreInitiallyCheckedItems="ignoreInitiallyCheckedItems"
                        :visibleColumnsFilter="visibleColumnsFilter"
                        :enableRowSelection="enableRowSelection"
                        :showCheckboxColumn="showCheckboxColumn"
                        :displayInBootstrapRow="true"
        >

          <template #bottom>
            <div class="modal-footer-container">
              <div class="modal-footer-bottom">
                <button class="btn btn-primary" @click="applySelectDrugstore"
                        :disabled="!selectedDrugstores || selectedDrugstores.length === 0">{{ okTitle }}
                </button>
              </div>

            </div>

          </template>

        </DrugstoresList>




      </div>


    </b-modal>
  </div>


</template>
<script>
import {defineComponent} from 'vue'
import DrugstoresList from "./DrugstoresList.vue";
import {BModal} from "bootstrap-vue-next";

export default defineComponent({
  name: "DrugstoreListModal",
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    multiselect: {
      type: Boolean,
      default: true,
    },
    showMassActions: {
      type: Boolean,
      default: () => true
    },
    showRowActions: {
      type: Boolean,
      default: () => true
    },
    showAddButton: {
      type: Boolean,
      default: () => true
    },
    selectedDrugstoresData: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: () => "Wybierz aptekę"
    },
    okTitle: {
      type: String,
      default: () => "Wybierz"
    },
    disableInitiallyCheckedItems: {type: Boolean, default: () => false},
    ignoreInitiallyCheckedItems: {type: Boolean, default: () => false},
    visibleColumnsFilter:{ // declare only columns keys You want to see
      type:Array,
      default: ()=>[]
    },
    enableRowSelection: {
      type: Boolean,
      default: () => true
    },
    showCheckboxColumn: {
      type: Boolean,
      default: () => true
    },
  },
  emits: ["update:showModal", "onApply", "onClose"],
  components: {DrugstoresList, BModal},
  data() {
    return {
      showModalInternal: this.showModal,
      selectedDrugstores: null,
    }
  },

  methods: {

    selectDrugstores(itemsData) {
      this.selectedDrugstores = itemsData
    },
    selectDrugstore(drugstore) {
      this.selectedDrugstores = [drugstore]
    },
    applySelectDrugstore() {
      this.$emit("onApply", this.selectedDrugstores)
    },
    closeModal() {
      this.showModalInternal = false
      this.$emit("onClose")
    }
  },
  watch: {
    // Watch parent prop changes and sync
    showModal(newValue) {
      this.showModalInternal = newValue;
    },
    // Watch local copy and emit to parent
    showModalInternal(newValue) {
      this.$emit('update:showModal', newValue);
    }
  },
})
</script>
<style scoped>
.modal-footer-container {
  position: sticky;
  bottom: -19px;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 60;
  padding: 0;
}

.modal-footer-bottom {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 24px;
}

</style>
